import { IProductData, IProductDataResults, ISku, ISkuData } from '../api/Interfaces';

const getProductSkuMap = (product: IProductData) => (skuData: ISkuData, sku: ISku) => {
    const { skus, ...productDetails } = product;
    const newSku = { ...productDetails, ...sku };

    return { ...skuData, [sku.skuId]: newSku };
};

export const mapProductSkusById = (data: IProductDataResults, product: IProductData) => {
    const skusData = product.skus.reduce(getProductSkuMap(product), {});

    return { ...data, ...skusData };
};
